
export type CreateTweetJsonBodyMediaItemType = typeof CreateTweetJsonBodyMediaItemType[keyof typeof CreateTweetJsonBodyMediaItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTweetJsonBodyMediaItemType = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
} as const;
